<template>
  <div class="pop-coupon">
    <div v-for="(item, index) in lotteryCode" :key="index" class="pop-coupon-number">{{ item }}</div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'LotteryPopupCoupon',
  data () {
    return {}
  },
  computed: {
    lotteryCode () {
      return commonUtils.formatToArr(this.$store.state.lottery.lotteryCode)
    }
  }
}
</script>

<style lang="less" scoped>
.pop-coupon {
  width: 233px;
  height: 87px;
  margin: 10px auto 10px auto;
  background: url('../../../assets/images/lottery/pop_jq.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  padding: 0 36px;
  box-sizing: border-box;
  justify-content: space-between;
  .pop-coupon-number {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    color: #e7610f;
    border: 2px solid #e7610f;
    background-color: #fff;
    text-align: center;
    line-height: 17px;
    font-weight: bold;
    margin-top: 50px;
  }
}
</style>
